// NOTE - we were given some direction from data capture and other data consumers that we help adoption of Object Action naming conventions for event naming.
// https://segment.com/academy/collecting-data/naming-conventions-for-clean-data/
import shapeCommonData from './shape-common-data';
import { SEGMENT_EVENTS_SCHEMA_PREFIX, TRACK_EVENT_PRODUCT_REMOVED_SCHEMA } from './constants';

export const PRODUCT_REMOVED_EVENT_NAME = 'Product Removed';
export const PRODUCT_REMOVED_EVENT_SCHEMA = `${SEGMENT_EVENTS_SCHEMA_PREFIX}${TRACK_EVENT_PRODUCT_REMOVED_SCHEMA}`;

export const buildProductRemovedEvent = ({
  brand,
  cartId,
  productId,
  skuId,
  pid,
  pdpUrl,
  productName,
  price,
  quantity = 1,
  cartItemIndexById = 0,
  styleColor,
  category,
  currency,
}) => [
  PRODUCT_REMOVED_EVENT_NAME,
  {
    ...shapeCommonData({
      pdpUrl,
      brand,
      cartId,
      productId,
      skuId,
      pid,
      productName,
      price,
      quantity,
      styleColor,
      category,
      currency,
    }),
    position: cartItemIndexById + 1,
  },
];
